// import flowbite to select dropdown
import "flowbite";

// src/index.js
import "./css/tailwind.css";
import "./scss/global.scss";
import "./js/global";
import "./js/plans_form";
import "./js/press";
import "./js/specialties";
import "./js/units";
import "./js/units-map";
import "./js/youtube_controls";
import "./js/components/cohesion-components";
import "./js/components/carousel-texto-imagem";
import "./js/components/tabs";
import "./js/components/tabs-cohesion";
import "./js/components/cohesion-map-geolocation";
import "./js/components/tabela-modal";
import "./js/components/share-modal";
import "./js/components/items-list-modal-autofix";
import "./js/components/hsl-scroll-horizontal-grid";
